import React from "react";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { LocaleProvider } from "./LocaleContext";
import { MenuProvider } from "../Menu/MenuContext";
import themes from "../../config/themes";

import { QueryClientProvider } from "@tanstack/react-query";
import queryClient from "../../api/queryClient";

const muiTheme = createTheme(themes[0].source as any);

export const AppProviders: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <LocaleProvider>
          <ThemeProvider theme={muiTheme}>
            <CssBaseline />
            <MenuProvider>
              {children}
            </MenuProvider>
          </ThemeProvider>
        </LocaleProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
};

export default AppProviders;
